import axios from 'axios'
import router from '@/router'
import store from '@/store'

/**
 * 资产页面沿用原来的 this.$http。
 * 成功码仍是 0。平台页面继续走 api/request.js，成功码是 200。
 */
const http = axios.create({
  withCredentials: true,
  timeout: 60000
})

http.interceptors.request.use(config => {
  const token = store.state.token
  if (token) {
    config.headers.token = token
    config.headers.Authorization = 'Bearer ' + token
  }
  const isForm = typeof FormData !== 'undefined' && config.data instanceof FormData
  if (!isForm && !config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json; charset=utf-8'
  }
  return config
}, error => Promise.reject(error))

http.interceptors.response.use(response => response, error => {
  const status = error.response && error.response.status
  if (status === 401) {
    store.commit('logout')
    if (router.currentRoute.path !== '/login') {
      router.push('/login')
    }
  }
  return Promise.reject(error)
})

/** 页面里的地址是 /asset/...，代理前缀是 /api。导出地址栏带上令牌。 */
http.adornUrl = (actionName) => {
  const path = actionName.startsWith('/') ? actionName : '/' + actionName
  let url = '/api' + path
  const token = store.state.token
  if (token) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + 'token=' + encodeURIComponent(token)
  }
  return url
}

http.adornParams = (params = {}) => params

http.adornData = (data = {}, openDefault = true, contentType = 'json') => {
  const payload = data || {}
  if (contentType !== 'json') {
    const params = new URLSearchParams()
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined && payload[key] !== null) {
        params.append(key, payload[key])
      }
    })
    return params.toString()
  }
  return JSON.stringify(payload)
}

export default http
